var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "we-chat": _vm.isInWechat }, attrs: { id: "app" } },
    [
      _c(
        "keep-alive",
        [this.$route.meta.keepAlive ? _c("router-view") : _vm._e()],
        1
      ),
      !this.$route.meta.keepAlive ? _c("router-view") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }